import GroupObject from "../objects/group"
import Calc from "@/common/util/calculator"
import BaseFixmethod from "@/signomatic/app/fixmethods/base"
import CircleObject from "@/signomatic/app/objects/circle"
import ImageObject from "@/signomatic/app/objects/image"
import RectObject from "@/signomatic/app/objects/rect"

export default class KeyringFixmethod extends BaseFixmethod {
  get visualPadding() {
    return { top: Calc.mmToPx(12), bottom: 0, left: 0, right: 0 }
  }

  topDrawable() {
    const { widthPx, heightPx } = this.state
    const items = []
    const outerWidth = 1 / this.drawables.scale
    const holeStroke = "#aaa"
    const holeFill = "#F5F7F6"
    const positions = this.positions()
    const holeRadius = this.isStainless ? Calc.mmToPx(1.75) : Calc.mmToPx(2)
    const holeTop = positions[0].top

    if (positions[0].center) {
      items.push(
        new CircleObject({
          radius: holeRadius,
          left: -holeRadius,
          top: holeTop,
          stroke: holeStroke,
          strokeWidth: outerWidth,
          fill: holeFill,
        }).addClass("hang", "keyring")
      )
      // stretch
      items.push(
        new CircleObject({
          radius: holeRadius,
          left: -holeRadius,
          top: heightPx - holeTop,
          strokeWidth: outerWidth,
          stroke: "transparent",
          fill: "transparent",
        })
      )
    } else {
      const holeLeft = positions[0].left || 0

      items.push(
        new CircleObject({
          radius: holeRadius,
          left: holeLeft,
          top: holeTop,
          stroke: holeStroke,
          strokeWidth: outerWidth,
          fill: holeFill,
        }).addClass("hang", "keyring")
      )

      // stretch
      items.push(
        new CircleObject({
          radius: holeRadius,
          left: widthPx - holeLeft,
          top: heightPx - holeTop,
          strokeWidth: outerWidth,
          stroke: "transparent",
          fill: "transparent",
        })
      )
    }

    return [
      new GroupObject(items, {
        left: 0,
        top: 0,
        width: widthPx,
        height: heightPx,
      }),
      this.topKeyringDrawable()[0],
    ]
  }

  topKeyringDrawable() {
    const { widthPx, heightPx } = this.state
    const items = []
    const positions = this.positions()
    const holeTop = positions[0].top
    const keyringHeigh = Calc.mmToPx(18.3)
    const keyringWidth = Calc.mmToPx(17.4)
    const frontImg = this.image("keyring_front.png")

    if (positions[0].center) {
      const left = positions[0].center - Calc.mmToPx(6.45)
      const top = holeTop - Calc.mmToPx(8.45)
      if (frontImg) {
        items.push(
          new ImageObject(frontImg, {
            left,
            top,
            scaleX: (keyringWidth || 0) / (frontImg.naturalWidth || frontImg.width),
            scaleY: (keyringHeigh || 0) / (frontImg.naturalHeight || frontImg.height),
          }).addClass("preview")
        )
        items.push(
          new RectObject({
            fill: "transparent",
            width: keyringWidth,
            height: keyringHeigh,
            left: widthPx - left,
            top: heightPx - top,
          }).addClass("preview")
        )
      }
    } else {
      const left = (positions[0].left || 0) - (this.isStainless ? Calc.mmToPx(6.17) : Calc.mmToPx(6.45))
      const top = holeTop - (this.isStainless ? Calc.mmToPx(16.75) : Calc.mmToPx(16.85))

      if (frontImg) {
        items.push(
          new ImageObject(frontImg, {
            left,
            top,
            scaleX: (keyringWidth || 0) / (frontImg.naturalWidth || frontImg.width),
            scaleY: (keyringHeigh || 0) / (frontImg.naturalHeight || frontImg.height),
          }).addClass("preview")
        )
        items.push(
          new RectObject({
            fill: "transparent",
            left: widthPx - left,
            top: heightPx - holeTop,
            width: keyringWidth,
            height: keyringHeigh,
          }).addClass("preview")
        )
      }
    }

    return [
      new GroupObject(items, {
        left: 0,
        top: 0,
        width: keyringWidth,
        height: keyringHeigh,
      }),
    ]
  }

  bottomDrawable() {
    const { widthPx, heightPx } = this.state
    const items = []
    const positions = this.positions()
    const holeTop = positions[0].top
    const keyringHeigh = Calc.mmToPx(16.9)
    const keyringWidth = Calc.mmToPx(13.7)
    const backImg = this.image("keyring_back.png")

    if (positions[0].center) {
      const left = positions[0].center - Calc.mmToPx(9.25)
      const top = holeTop - Calc.mmToPx(8.15)
      if (backImg) {
        items.push(
          new ImageObject(backImg, {
            left,
            top,
            scaleX: (keyringWidth || 0) / (backImg.naturalWidth || backImg.width),
            scaleY: (keyringHeigh || 0) / (backImg.naturalHeight || backImg.height),
          }).addClass("preview")
        )
        items.push(
          new RectObject({
            fill: "transparent",
            width: keyringWidth,
            height: keyringHeigh,
            left: widthPx - left,
            top: heightPx - top,
          }).addClass("preview")
        )
      }
    } else {
      const left = (positions[0].left || 0) - (this.isStainless ? Calc.mmToPx(8.92) : Calc.mmToPx(9.25))
      const top = holeTop - (this.isStainless ? Calc.mmToPx(16.15) : Calc.mmToPx(16.25))

      if (backImg) {
        items.push(
          new ImageObject(backImg, {
            left,
            top,
            scaleX: (keyringWidth || 0) / (backImg.naturalWidth || backImg.width),
            scaleY: (keyringHeigh || 0) / (backImg.naturalHeight || backImg.height),
          }).addClass("preview")
        )
        items.push(
          new RectObject({
            fill: "transparent",
            left: widthPx - left,
            top: heightPx - holeTop,
            width: keyringWidth,
            height: keyringHeigh,
          }).addClass("preview")
        )
      }
    }

    return new GroupObject(items, {
      left: 0,
      top: 0,
      width: keyringWidth,
      height: keyringHeigh,
    })
  }

  engravingDrawable() {
    const { widthPx, heightPx } = this.state
    const items = []
    const outerWidth = this.drawables.engravingStrokeWidth
    const holeStroke = this.drawables.engravingColor
    const holeFill = "transparent"

    const positions = this.positions()
    const holeRadius = Calc.mmToPx(2)
    const holeTop = positions[0].top

    if (positions[0].center) {
      items.push(
        new CircleObject({
          radius: holeRadius,
          left: -holeRadius,
          top: holeTop,
          stroke: holeStroke,
          strokeWidth: outerWidth,
          fill: holeFill,
        }).addClass("hang", "keyring")
      )
      // stretch
      items.push(
        new CircleObject({
          radius: holeRadius,
          left: -holeRadius,
          top: heightPx - holeTop,
          stroke: "transparent",
          strokeWidth: outerWidth,
          fill: "transparent",
        })
      )
    } else {
      const holeLeft = positions[0].left || 0

      items.push(
        new CircleObject({
          radius: holeRadius,
          left: holeLeft,
          top: holeTop,
          stroke: holeStroke,
          strokeWidth: outerWidth,
          fill: holeFill,
        }).addClass("hang", "keyring")
      )

      // stretch
      items.push(
        new CircleObject({
          radius: holeRadius,
          left: widthPx - holeLeft,
          top: heightPx - holeTop,
          stroke: "transparent",
          strokeWidth: outerWidth,
          fill: "transparent",
        })
      )
    }

    return [
      new GroupObject(items, {
        left: 0,
        top: 0,
        width: widthPx,
        height: heightPx,
      }),
    ]
  }

  protected imagePaths() {
    return ["/images/signomatic/fix_methods/keyring_front.png", "/images/signomatic/fix_methods/keyring_back.png"]
  }

  private positions() {
    const { widthPx, shape, material } = this.state
    const pos = []
    const hasBorder = this.drawables.hasBorder
    const signType = this.drawables.signType
    const alu = signType === "aluminium_sign"
    const plastic =
      signType === "plastic_sign" ||
      (signType == "label_plates" && ["regular", "aluminium", "aluminium_lacquered"].includes(material))

    let diameter = Calc.mmToPx(4)
    const center = widthPx / 2
    const relOptions = { maxWidth: 150, maxHeight: 100 }

    if (alu) {
      if (shape === "round") {
        const distance = hasBorder
          ? this.drawables.sizeRelative("height", Calc.mmToPx(4.5), Calc.mmToPx(7), relOptions)
          : this.drawables.sizeRelative("height", Calc.mmToPx(4), Calc.mmToPx(6), relOptions)
        pos.push({ left: distance, top: distance, diameter })
      } else if (["rotated_rect", "ellipse"].includes(shape)) {
        const min = hasBorder ? 4.5 : 4
        const top = this.drawables.sizeRelative("height", Calc.mmToPx(min), Calc.mmToPx(7), relOptions)
        pos.push({ center, top, diameter })
      } else if (shape === "stop") {
        const top = hasBorder
          ? this.drawables.sizeRelative("height", Calc.mmToPx(4.5), Calc.mmToPx(7), relOptions)
          : this.drawables.sizeRelative("height", Calc.mmToPx(4), Calc.mmToPx(6), relOptions)
        pos.push({ center, top, diameter })
      }
    } else if (plastic) {
      if (shape === "rect") {
        const min = hasBorder ? 4.2 : 3.5
        const distance = this.drawables.sizeRelative("height", Calc.mmToPx(min), Calc.mmToPx(7), relOptions)
        pos.push({ left: distance, top: distance, diameter })
      } else if (shape === "round") {
        const distance = hasBorder
          ? this.drawables.sizeRelative("height", Calc.mmToPx(4.2), Calc.mmToPx(8.5), relOptions)
          : this.drawables.sizeRelative("height", Calc.mmToPx(3.5), Calc.mmToPx(7), relOptions)
        pos.push({ left: distance, top: distance, diameter })
      } else if (["ellipse", "stop"].includes(shape)) {
        const min = hasBorder ? 4.2 : 3.5
        const top = this.drawables.sizeRelative("height", Calc.mmToPx(min), Calc.mmToPx(7), relOptions)
        pos.push({ center, top, diameter })
      } else if (shape === "rotated_rect") {
        const min = hasBorder ? 4.5 : 3
        const top = this.drawables.sizeRelative("height", Calc.mmToPx(min), Calc.mmToPx(8), relOptions)
        pos.push({ center, top, diameter })
      }
    } else if (this.isStainless) {
      const top = Calc.mmToPx(4)
      diameter = Calc.mmToPx(3.5)
      const holeLeft = ["rect", "round"].includes(shape)

      pos.push({ left: holeLeft ? top : center, top, diameter })
    }

    return pos
  }
}
